<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.pickShelfs'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.associateSerialNo"
            :placeholder="$t('stock.associateSerialNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.remark"
            :placeholder="$t('text.remark')"
          />
        </el-form-item>
        <date-range
          v-model="searchForm"
          type="datetime"
          field="createAt"
          :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
          :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
        />

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              type="success"
              size="mini"
              :loading="buildPickingListDoing"
              @click="buildPickingList"
              >{{ $t("action.buildPickingList") }}</el-button
            >
            <el-button type="primary" size="mini" @click="backPickShelf">
              {{ $t("action.pickShelf") }}
            </el-button>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>

      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :loading="loading"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        id="deliveryTable"
        :span-method="mergeMethod"
        :row-class-name="calculateBgColor"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <span v-if="!row.isMergeLine">
              <thumbnail :images="row.images" />
            </span>
            <div v-else>
              <span>
                {{ row.serialNo }}
                <span class="font10">
                  ({{ $t("deliverTypes." + row.deliverType) }})
                </span>
                <span v-if="row.deliverType == 'express'" class="font10">
                  {{ row.express }}&nbsp;&nbsp;
                  {{ row.tracking }}
                </span>
                <span v-if="row.deliverType == 'carry'" class="font10">
                  {{ row.sender }}
                </span>
              </span>
              <span v-if="row.batchSerialNo != null" class="font10 mgl10">
                {{ $t("delivery.batchSerialNo") }}:
                {{ row.batchSerialNo }}
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="140"
        >
          <template v-slot="{ row }">
            {{ row.associateSerialNo }}
            <div v-if="row.pickListId != null" class="green font10">
              出库清单
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="50"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}
            <div class="font10">
              {{ $t("pickShelf.pickedQty") }}：{{ row.pickQuantity }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="shopName"
          :title="$t('menu.warehouses')"
          min-width="80"
        />
        <vxe-table-column
          field="inventory"
          :title="$t('inventory.inventoryInfo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span
              v-if="
                row.inventory !== null &&
                row.inventory.inventoryShelfs.length !== 0
              "
            >
              <div
                v-for="(item, index) of row.inventory.inventoryShelfs"
                :key="index"
                class="font10"
              >
                {{ item.shelfName }}：{{ item.quantity }}
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handlerName"
          :title="$t('text.remark')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="10"
              type="richText"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
        <vxe-table-column
          field="picker"
          :title="$t('pickShelf.picker')"
          min-width="60"
        >
          <template v-slot="{ row }">
            {{ row.picker }}
            <div class="font10">{{ row.pickAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="finishAt"
          :title="$t('pickShelf.finishAt')"
          min-width="110"
        />

        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="70"
          fixed="right"
        >
          <template v-slot="{ row }">
            <template v-if="!row.isMergeLine">
              <el-button
                v-if="row.finishAt == null"
                type="text"
                size="mini"
                @click="pickShelf(row)"
              >
                {{ $t("action.pickShelf") }}
              </el-button>
            </template>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- 出库 -->
    <el-dialog
      :title="$t('action.pickShelf')"
      :close-on-click-modal="false"
      :visible.sync="pickShelfDF"
      width="30%"
    >
      <el-form ref="pickShelfObjForm" :model="pickShelfObj" label-width="80px">
        <el-form-item
          :label="$t('menu.shelfs')"
          :prop="'shelfId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.shelfs')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="pickShelfObj.shelfId"
            filterable
            clearable
            @change="selectInventoryShelf"
          >
            <el-option
              v-for="item of rowInventoryShelfs"
              :key="item.shelfId"
              :label="item.text"
              :value="item.shelfId"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('text.quantity')"
          :prop="'quantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            :placeholder="pickShelfObj._maxQuantity"
            v-model.trim="pickShelfObj.quantity"
          />
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="pickShelfObj.remark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="pickShelfSubmitDoing"
          size="small"
          @click="pickShelfSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="pickShelfDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 出库 -->
    <el-dialog
      :title="$t('action.pickShelf')"
      :close-on-click-modal="false"
      :visible.sync="batchPickShelfDF"
      width="60%"
    >
      <el-form
        ref="batchPickShelfObjForm"
        :model="batchPickShelfObj"
        label-width="80px"
      >
        <vxe-table
          :data="backPickItems"
          size="mini"
          resizable
          round
          auto-resize
          highlight-hover-row
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column
            field="images"
            :title="$t('product.images')"
            width="80"
          >
            <template v-slot="{ row }">
              <thumbnail :images="row.images" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="associateSerialNo"
            :title="$t('stock.associateSerialNo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              {{ row.associateSerialNo }}
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="productNo"
            :title="$t('product.productNo')"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.productNo }}
              <div class="font10">{{ row.color }} {{ row.size }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="quantity"
            :title="$t('text.quantity')"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.quantity }}
              <div class="font10">
                {{ $t("pickShelf.pickedQty") }}：{{ row.pickQuantity }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="inventory"
            :title="$t('inventory.inventoryInfo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              <span
                v-if="
                  row.inventory !== null &&
                  row.inventory.inventoryShelfs.length !== 0
                "
              >
                <div
                  v-for="(item, index) of row.inventory.inventoryShelfs"
                  :key="index"
                  class="font10"
                >
                  {{ item.shelfName }}：{{ item.quantity }}
                </div>
              </span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="_quantity"
            :title="$t('pickShelf.pickQuantity')"
            min-width="100"
          >
            <template v-slot="{ row }">
              <el-input
                size="mini"
                v-model.trim="row._quantity"
                :placeholder="$t('pickShelf.pickQuantity')"
              />
              <!-- {{ row._quantity }} -->
              <el-select
                size="mini"
                v-model="row._shelfId"
                filterable
                clearable
                :placeholder="$t('menu.shelfs')"
              >
                <el-option
                  v-for="item of row._rowShopShelfs"
                  :key="item.shelfId"
                  :label="item.text"
                  :value="item.shelfId"
                />
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="remark"
            :title="$t('text.remark')"
            min-width="80"
          >
            <template v-slot="{ row }">
              <raw-html-limit-number :content="row.remark" :number="16" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="createAt"
            :title="$t('text.createAt')"
            width="110"
          />

          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="50"
          >
            <template v-slot="{ row, rowIndex }">
              <el-button type="text" size="mini" @click="remove(row, rowIndex)">
                {{ $t("text.remove") }}
              </el-button>
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <span class="mgr10">
          {{ $t("text.total") }}：{{ countCurrnetTotal() }}
        </span>
        <el-button
          type="primary"
          plain
          :loading="batchPickShelfSubmitDoing"
          size="small"
          @click="batchPickShelfSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="batchPickShelfDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Thumbnail from "@/components/Thumbnail";
import DateRange from "@/components/DateRange";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import RawHtml from "@/components/RawHtml";

import Shop from "@/api/shop.js";
import PickShelf from "@/api/pickShelf.js";
import Inventory from "@/api/inventory.js";
import Delivery from "@/api/delivery.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Thumbnail,
    RawHtmlLimitNumber,
    DateRange,
    RawHtml,
  },
  data() {
    return {
      Util: Util,
      narrows: [
        [
          {
            label: this.$t("pickShelf.pickShelfInfo"),
            items: [
              {
                label: this.$t("pickShelfInfo.yes"),
                key: "yes",
                condition: { finish: "yes" },
              },
              {
                label: this.$t("pickShelfInfo.no"),
                key: "no",
                condition: { finish: "no" },
              },
            ],
          },
          {
            label: this.$t("pickShelf.pickListInfo"),
            items: [
              {
                label: this.$t("pickListInfos.yes"),
                key: "havePickListIdYes",
                condition: { havePickListId: "yes" },
              },
              {
                label: this.$t("pickListInfos.no"),
                key: "havePickListIdNo",
                condition: { havePickListId: "no" },
              },
            ],
          },
        ],
      ],

      initFilter: "no",
      searchForm: {
        productNo: null,
        remark: null,
        createStartAt: null,
        createEndAt: null,
        shopId: null,
        associateSerialNo: null,
      },
      sorter: {
        sortBy: "deliveries_id",
        sortIndicator: "desc",
      },
      shops: [],
      shopsView: [],
      //
      row: null,
      pickShelfDF: false,
      pickShelfObj: {
        id: null,
        shelfId: null,
        quantity: null,
        remark: null,
        _maxQuantity: null,
      },
      rowInventoryShelfs: [],
      pickShelfSubmitDoing: false,
      //
      buildPickingListDoing: false,
      //
      backPickItems: [],
      batchPickShelfDF: false,
      batchPickShelfObj: {},
      batchPickShelfSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    axios.all([Shop.findByTenantId()]).then(
      axios.spread(function (shops) {
        if (shops.status === 200) {
          self.shops = shops.data;
          if (self.Permit.currentUser().admin) {
            self.shopsView = self.shops;
          } else {
            self.shopsView = self.shops.filter(
              (s) =>
                self.Permit.wmsViewShopIds().includes(s.id) &&
                s.isInventory == true
            );
          }
          if (self.shopsView.length !== 0) {
            self.narrows.push([
              {
                label: self.$t("menu.warehouses"),
                items: self.shopsView.map((shop) => {
                  return {
                    label: shop.name,
                    key: shop.id,
                    condition: { shopId: shop.id },
                  };
                }),
              },
            ]);
          }
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    backPickShelf() {
      const self = this;
      if (self.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.backPickItems = [];
      for (const s of self.selectRecords) {
        self.backPickItems = self.backPickItems.concat(s.pickShelfs);
      }
      const shopIds = this.backPickItems.map((s) => s.shopId);
      const shopIdsSet = [...new Set(shopIds)];
      if (shopIdsSet.length > 1) {
        this.$message({
          message: self.$t("prompt.selectDifferWarehouseData"),
          type: "warning",
        });
        return;
      }
      for (const s of this.backPickItems) {
        Vue.set(s, "_quantity", s.quantity - s.pickQuantity);
        Vue.set(s, "_maxQuantity", s.quantity - s.pickQuantity);
        if (s.inventory != null) {
          s.inventory.inventoryShelfs.forEach((shelf) =>
            Vue.set(shelf, "text", shelf.shelfName + "(" + shelf.quantity + ")")
          );
          Vue.set(s, "_rowShopShelfs", s.inventory.inventoryShelfs);
          Vue.set(
            s,
            "_shelfId",
            s.inventory.inventoryShelfs.length == 1
              ? s.inventory.inventoryShelfs[0].shelfId
              : null
          );
        } else {
          Vue.set(s, "_rowShopShelfs", []);
          Vue.set(s, "_shelfId", null);
        }
      }
      self.batchPickShelfDF = true;
    },
    remove(row, rowIndex) {
      this.backPickItems.splice(rowIndex, 1);
    },
    countCurrnetTotal() {
      let total = 0;
      if (this.backPickItems.length === 0) {
        return 0;
      }
      this.backPickItems.map((i) => {
        total += Number(i._quantity);
      });
      return total;
    },
    batchPickShelfSubmit() {
      const self = this;
      if (self.backPickItems.length === 0) {
        self.$message.error(self.$t("prompt.atLeastOneData"));
        return;
      }
      for (const i of self.backPickItems) {
        if (
          !Util.regexQuantity(i._quantity) ||
          i._quantity == "0" ||
          i._quantity == 0 ||
          i._quantity > i._maxQuantity
        ) {
          this.$message({
            message: self.$t("rules.regex", [self.$t("text.quantity")]),
            type: "warning",
          });
          return;
        }
        if (i._shelfId == null) {
          this.$message({
            message: self.$t("rules.select", [self.$t("menu.shelfs")]),
            type: "warning",
          });
          return;
        }
        const shelfObj = i._rowShopShelfs.find((s) => s.shelfId == i._shelfId);
        if (i._quantity > shelfObj.quantity) {
          this.$message({
            message: self.$t("rules.beyondMaxQty", [shelfObj.quantity]),
            type: "warning",
          });
          return;
        }
      }

      const data = self.backPickItems.map((i) => {
        return {
          id: i.id,
          remark: null,
          quantity: i._quantity,
          shelfId: i._shelfId,
        };
      });
      self.batchPickShelfSubmitDoing = true;
      PickShelf.batchPick(data).then(function (res) {
        self.batchPickShelfSubmitDoing = false;
        if (res.status == 200) {
          self.sysResults(res.data, self.$t("prompt.pickSuccess"));
          self.loadData();
          self.batchPickShelfDF = false;
          self.$eventHub.$emit("pickShelfBatchPick");
        } else {
          self.sysError();
        }
      });
    },

    // 拣货清单
    buildPickingList() {
      const self = this;
      if (self.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      let pickShelfIds = [];
      for (const selectRecord of self.selectRecords) {
        pickShelfIds = pickShelfIds.concat(
          selectRecord.pickShelfs.map((p) => p.id)
        );
      }
      const obj = {
        serialNo: Util.serialNo(),
        remark: null,
        pickShelfIds: pickShelfIds,
      };
      self.buildPickingListDoing = true;
      PickShelf.buildPickingList(obj).then(function (res) {
        self.buildPickingListDoing = false;
        if (res.status == 200) {
          self.sysResults(res.data, self.$t("prompt.buildPickingListSuccess"));
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },

    //
    pickShelf(row) {
      const self = this;
      self.row = row;
      self.pickShelfObj.id = row.id;
      self.pickShelfObj.shelfId = null;
      self.pickShelfObj.quantity = row.quantity - row.pickQuantity || 0;
      self.pickShelfObj.remark = null;
      self.rowInventoryShelfs = [];
      self.pickShelfSubmitDoing = false;
      self.pickShelfDF = false;
      if (row.inventory != null) {
        self.rowInventoryShelfs = row.inventory.inventoryShelfs;
        self.rowInventoryShelfs.forEach((shelf) =>
          Vue.set(shelf, "text", shelf.shelfName + "(" + shelf.quantity + ")")
        );
        if (self.rowInventoryShelfs.length == 1) {
          self.pickShelfObj.shelfId = self.rowInventoryShelfs[0].shelfId;
          self.selectInventoryShelf();
        }
        self.pickShelfDF = true;
      } else {
        if (row.shopId != null && row.productNo != null) {
          let obj = {
            productNo: row.productNo,
            color: row.color,
            size: row.size,
            shopId: row.shopId,
          };
          Inventory.findByProductInfo(obj).then(function (res) {
            if (res.data.code === 200) {
              const invInfo = res.data.entity;
              self.rowInventoryShelfs = invInfo.inventoryShelfs;
              self.rowInventoryShelfs.forEach((shelf) =>
                Vue.set(
                  shelf,
                  "text",
                  shelf.shelfName + "(" + shelf.quantity + ")"
                )
              );
              if (self.rowInventoryShelfs.length == 1) {
                self.pickShelfObj.shelfId = self.rowInventoryShelfs[0].shelfId;
                self.selectInventoryShelf();
              }
              self.pickShelfDF = true;
            } else {
              self.$message({
                message: self.$t("inventory.inventoryInfoNoExist"),
                type: "warning",
              });
            }
          });
        }
      }
    },
    selectInventoryShelf() {
      const self = this;
      if (
        self.rowInventoryShelfs.length != 0 &&
        self.pickShelfObj.shelfId != null
      ) {
        const obj = self.rowInventoryShelfs.find(
          (i) => i.shelfId == self.pickShelfObj.shelfId
        );
        self.pickShelfObj._maxQuantity =
          self.row.quantity > obj.quantity
            ? obj.quantity
            : self.row.quantity - self.row.pickQuantity || 0;
        return;
      }
    },
    pickShelfSubmit() {
      const self = this;
      self.$refs.pickShelfObjForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(this.pickShelfObj.quantity) ||
            this.pickShelfObj.quantity == "0" ||
            this.pickShelfObj.quantity == 0 ||
            this.pickShelfObj.quantity > this.pickShelfObj._maxQuantity
          ) {
            this.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.pickShelfSubmitDoing = true;
          PickShelf.pick(self.row.id, self.pickShelfObj).then(function (res) {
            self.pickShelfSubmitDoing = false;
            self.pickShelfDF = false;
            if (res.status === 200) {
              self.sysResult(res.data);
              self.loadData();
              self.$eventHub.$emit("pickShelfPick");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    //-----
    dataProvider(params) {
      return Delivery.pickSearch(params);
    },
    recordsDecorate(records) {
      this.records = this.buildTableData(records);
      this.mergeCells = this.buildMergeCells(records);
    },
    buildTableData(records) {
      let rs = [];
      records.forEach((record) => {
        let bPurchase = {
          isMergeLine: true,
          id: record.id,
          serialNo: record.serialNo,
          deliverBy: record.deliverBy,
          deliverAt: record.deliverAt,
          deliverCost: record.deliverCost,
          deliverType: record.deliverType,
          express: record.express,
          tracking: record.tracking,
          remark: record.remark,
          receiveAt: record.receiveAt,
          receiveBy: record.receiveBy,
          sender: record.sender,
          senderId: record.senderId,
          receiverId: record.receiverId,
          quantity: record.quantity,
          purchaseId: record.purchaseId,
          courierId: record.courierId,
          weight: record.weight,
          insured: record.insured,
          verifyAt: record.verifyAt,
          customerName: record.customerName,
          customerPhone: record.customerPhone,
          customerCountry: record.customerCountry,
          customerProvince: record.customerProvince,
          customerCity: record.customerCity,
          customerAddress: record.customerAddress,
          customerZipcode: record.customerZipcode,
          courierName: record.courierName,
          deliverMethodId: record.deliverMethodId,
          deliverMethodName: record.deliverMethodName,
          explain: record.explain,
          courierWeight: record.courierWeight,
          deliveryCheckId: record.deliveryCheckId,
          toPay: record.toPay,
          expressId: record.expressId,
          transType: record.transType,
          printTemplate: record.printTemplate,
          innerSerialNo: record.innerSerialNo,
          settle: record.settle,
          retrieveAt: record.retrieveAt,
          printAt: record.printAt,
          deliveryType: record.deliveryType,
          settlementId: record.settlementId,
          courierCost: record.courierCost,
          expressTenantId: record.expressTenantId,
          settleAt: record.settleAt,
          eOrderType: record.eOrderType,
          deliverId: record.deliverId,
          receiveRemark: record.receiveRemark,
          batchSerialNo: record.batchSerialNo,
          goodsName: record.goodsName,
          goodsNameEn: record.goodsNameEn,
          hsCode: record.hsCode,
          size: record.size,
          changeSpecsQuantity: record.changeSpecsQuantity,
          confirmAt: record.confirmAt,
          confirmId: record.confirmId,
          confirmName: record.confirmName,
          attachment: record.attachment,
          extraCharge: record.extraCharge,
          workflowState: record.workflowState,
          lastPickId: record.lastPickId,
          lastPickName: record.lastPickName,
          lastPickAt: record.lastPickAt,
          checkId: record.checkId,
          checkName: record.checkName,
          checkAt: record.checkAt,
          weightId: record.weightId,
          weightName: record.weightName,
          weightAt: record.weightAt,
          eorderType: record.eorderType,
          pickShelfs: record.pickShelfs,
        };
        rs.push(bPurchase); //将bargain的数据转换到格式，放到数据列表
        record.pickShelfs.forEach((pickShelf) => {
          rs.push(pickShelf);
        });
      });
      return rs;
    },
    buildMergeCells(records) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < records.length; i++) {
        mcs.push({ row: rowIdx, col: 1, rowspan: 1, colspan: 9 });
        rowIdx = rowIdx + records[i].pickShelfs.length + 1;
      }
      return mcs;
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isMergeLine
        ? "light-blue-bg"
        : this.rowBgColor({ row: row, rowIndex: rowIndex });
    },

    // 可选
    checCheckboxMethod({ row }) {
      if (
        row.isMergeLine &&
        row.pickShelfs &&
        row.pickShelfs.length ==
          row.pickShelfs.filter((p) => p.pickListId == null).length
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
